import { LitElement, html, css } from 'lit';
import { BLACKLAB_BASE } from '../eplib-constants.js';
import { BootstrapCSS } from '../../resources/css/bootstrap.css';
import { EplibStyles } from '../../resources/css/style.css.js';

export class EplibContentView extends LitElement {
  static get properties() {
    return {
      ...super.properties,
      title: {
        type: String
      },
      shortTitle: {
        type: String
      },
      description: {
        type: String
      },
      witnessNote: {
        type: String
      }
    }
  }

  async firstUpdated() {
    super.firstUpdated();

    const doc = window.location.pathname.split('/').pop().split('.').shift();
    const meta = await this._getMeta(doc);
    this.title = Array.isArray(meta.display_title) ? meta.display_title[0] : meta.display_title;
    this.shortTitle = this.title.length > 120 ? this.title.substring(0, 120) + '...' : this.title;
    document.title = this.title.substring(0, 150); // maximum search engines will index
    document.querySelector("meta[name='author']").setAttribute('content', meta.author);
    let description = 'Transcription ' + doc + ' of ';
    if (meta.estc) {
      if (Array.isArray(meta.estc)) {
        meta.estc.forEach(idno => {
          description += idno + '; '
        });
      }
      else {
        description += meta.estc + '; '
      }
    }
    if (meta.display_year) description += 'published ' + meta.display_year;
    this.description = description;
    document.querySelector("meta[name='description']").setAttribute('content', this.description);
    this.witnessNote = meta.witness_note ? meta.witness_note : '';
  }

  async _getMeta(doc) {
    let url = `${BLACKLAB_BASE}/docs/${doc}?outputformat=json`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        credentials: 'same-origin'
      });
      if (!response.ok) {
        throw new Error(`Network response was not OK: ${response.error}`);
      }
      const data = await response.json();
      if (data.error) {
        throw new Error("Data error: `${data.error}");
      }
      return data.docInfo;
    }
    catch (error) {
      alert(`Error retrieving metadata for ${doc}: ${error}`);
    }
  }

  static get styles() {
    return [
      BootstrapCSS,
      EplibStyles,
      css`
        #description {
          color: #983722;
          font-size: 1rem;
        }
      `
    ];
  }

  render() {
    return html`
    <div class="row actions-row">
      <div class="col-md-12">
        <eplib-action-bar></eplib-action-bar>
      </div>
    </div>
    <div id="main-container" class="container-fluid">
      <div class="row">
        <eplib-table-of-contents class="col-md-3"></eplib-table-of-contents>
        <div id="right-panel" class="col-md-12 col-xs-12">
          <div class="container-fluid">
            <div class="row doc-area">
              <div class="col-sm-6">
                <div id="content-inner">
                  <h1 id="description">${this.description}</h1>
                  <div id="content-container" class="well">
                    <div class="page-header col-title">
                      <h3 title="${this.title}">${this.shortTitle}</h3>
                    </div>
                    <eplib-document-content></eplib-document-content>
                  </div>
                </div>
              </div>
              <eplib-facsimile witnessNote="${this.witnessNote}" class="col-sm-6"></eplib-facsimile>
              <eplib-annotation-panel-helper></eplib-annotation-panel-helper>
              <aside id="annotations" hidden="true" draggable="true">
                <annotation-panel id="annotation-panel" server="/exist/apps/annotation-service/annotation">
                  <div slot="annotations"/>
                </annotation-panel>
              </aside>
            </div>
            <div class="row col-md-12">
              <eplib-page-slider></eplib-page-slider>
            </div>
          </div>
        </div>
      </div>  
    </div>
  `;
  }
}

customElements.define('eplib-content-view', EplibContentView);